import {i18n} from '@online-offer/i18n';
import {Show} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import {FinancialProductOffer, FinancialProductType} from '../../api/types/onlineOfferTypes';
import {RadioButtonGroup} from '../../components/RadioButtonGroup/RadioButtonGroup';
import {getFinancialProductTypeLabelKey} from './getFinancialProductTypeLabelKey';

const PRODUCT_ORDER: FinancialProductType[] = ['BALLOON', 'STANDARD', 'LEASING'];

interface FinancialProductTabsProps extends TestIdProps {
  offers: FinancialProductOffer[];
  value: FinancialProductType;
  onChange: (value: FinancialProductType) => void;
}

export function FinancialProductTabs(props: FinancialProductTabsProps) {
  const offers = [...props.offers].sort(
    (left, right) =>
      PRODUCT_ORDER.indexOf(left.productType) - PRODUCT_ORDER.indexOf(right.productType)
  );

  return (
    <Show when={offers.length > 1}>
      <RadioButtonGroup
        label={i18n.t('financialProducts.productSelection')}
        value={props.value}
        options={offers.map((offer) => ({
          value: offer.productType,
          label: i18n.t(getFinancialProductTypeLabelKey(offer.productType)),
          'data-testid': suffixTestId(`segmentItem-${offer.productType}`, props),
        }))}
        onChange={props.onChange}
        appearance="pill"
        data-testid={props['data-testid']}
      />
    </Show>
  );
}
